import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheJsService {

    private mapObject: {[key: string]: any} = {};
    private mapMapObject: {[key: string]: {[key: string]: any}} = {};

    constructor() { }

    addKeyValue(key: string, data: any) {
      this.mapObject[key] = data;
    }

    addGroupKeyValue(group: string, key: string, data: any) {
      if (this.mapMapObject[group] == null) {
          this.mapMapObject[group] = {};
      }
      this.mapMapObject[group][key] = data;
    }

    existKey(key: string) {
        return this.mapObject[key] != null;
    }

    existGroupKey(group: string, key: string) {
        return this.mapMapObject[group] != null && this.mapMapObject[group][key] != null;
    }

    getValueByKey(key: string) {
        return this.mapObject[key];
    }

    getValueByGroupKey(group: string, key: string) {
      if (this.existGroupKey(group, key)) {
          return this.mapMapObject[group][key];
      } else {
          return null;
      }
    }
}
